
<template lang="">
  <el-dialog
    title="面对面访问"
    :visible.sync="visible"
    custom-class="dialog-version"
    :before-close="handleClose"
    width="764px"
    >
    <div slot="title">
      <div class="flex">
        <span>面对面访问</span>
        <img class="ml-2" width="152" :src="iconVersionImg" alt="尊享版及以上版本" />
      </div>
    </div>
    <div>
      <div v-if="type==='random'">
        <p class="text-center theme-title">随机面访</p>
        <div class="text-center theme-desc mb-6 mx-auto text-sm">
          <p>随机拦访样本开展调查，保证调查结果的客观性</p>
          <p>调查员通过“ 调研工厂调查员版 App ”开展调查，全程录音录像，支持离线调查，生成调查员调查轨迹。</p>
        </div>
        <img class="welcome-img w-full" src="@/assets/img/wj/random-welcome.png" />
      </div>
      <div v-else-if="type==='assign'">
        <p class="text-center theme-title">指定样本面访</p>
        <div class="text-center theme-desc mb-6 mx-auto text-sm">
          <p>从指定样本库中随机抽取指定样本，线下开展面访</p>
          <p>可应用于指定人群面访，指定地点检查等场景</p>
          <p>调查员通过“ 调研工厂调查员版 App ”开展调查，全程录音录像，支持离线调查，生成调查员调查轨迹。</p>
        </div>
        <img class="welcome-img w-full" src="@/assets/img/wj/assign-welcome.png" />
      </div>
      <div class="btns justify-center">
        <button @click="toVersionPrice" class="go-dtails">了解权益详情</button>
        <button @click="toVersionPrice" class="go-level relative">
          立即升级
          <span class="right-tips">86% 用户已升级</span>
        </button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import iconVersionImg from '@/assets/img/version/icon-version.png'
import GlobalConfig, { AuthConfig } from '@/global/config'
import { toVersionPrice } from '@/assets/js/base-platform'
export default {
  name:'DialogVersion',
  props:{
    visible:{
      type: Boolean,
    },
    type:{
      type: String,
      default:'random'
    }
  },
  data(){
    return {
      iconVersionImg,
    }
  },
  computed:{
    isCompanyPay() {
      let authCode = GlobalConfig.getAuthCode()
      return ![AuthConfig.TeamBase, AuthConfig.TeamPlus].includes(authCode)
    },
  },
  methods:{
    toVersionPrice,
    handleClose(){
      this.$emit('close',false);
    }
  }
}
</script>
<style scoped lang="scss">
  ::v-deep .el-dialog {
    &__header {
      @apply bg-theme-gray
    }
    .theme-title{
      font-weight: 500;
      font-size: 20px;
      line-height: 28px;
      color: rgba(0,0,0,0.85);
      @apply mb-4
    }
    .theme-desc{
      color: rgba(0,0,0,0.65);
      font-size: 14px;
      line-height: 22px;
      width: 684px;
    }
    .btns{
      display: flex;
      margin-top: 20px;
      text-align: center;
      position: relative;
      .go-dtails{
        width: 110px;
        height: 32px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #6B4D3B;
        background-color: #fff;
        cursor: pointer;
      }
      .go-level{
        width: 128px;
        height: 32px;
        background: #FEC08E;
        line-height: 32px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #6B4D3B;
        border-radius: 2px;
        cursor: pointer;
      }
      .right-tips{
        position: absolute;
        display: block;
        right: -55px;
        top: -10px;
        width: 102px;
        padding-left: 4px;
        padding-right: 4px;
        box-sizing: border-box;
        height: 18px;
        background: #E34152;
        border-radius: 2px;
        font-family: PingFangSC-SNaNpxibold;
        font-weight: 600;
        font-size: 10px;
        color: #FFFFFF;
        line-height: 18px;
      }
    }
  }
</style>
